import get from './get';

export default {
  namespaced: true,
  modules: {
    get,
  }
}
